import React from 'react';

import { Box } from '@mui/material';

import { PatientMedicalNoteServiceItem, PaymentTypeName } from '@uplift/api';
import { DescriptionOfService } from './DescriptionOfService.component';
import { BillingDetails, getInsuranceBillingReportItems } from './BillingDetails.component';
import { WhatDoTheseTermMeans } from './WhatDoTheseTermMeans.components';
import { mobileBreakpoint, useIsMobile } from '@uplift/hooks';
import { SessionDetailsDescription } from './SessionDetailsDescription.component';


export const useMedicalNoteServiceResponsibilities = (row: PatientMedicalNoteServiceItem) => {
  const { payment } = row;

  return React.useMemo(() => {
    const result: {title: string; value: number | string}[] = [];

    if (payment?.type === PaymentTypeName.insurance) {
      return getInsuranceBillingReportItems(payment);
    }

    if (payment?.type === PaymentTypeName.cash) {
      result.push({ title: 'Your responsibility', value: payment.payment?.amountCents });
    }

    return result;
  }, [ payment ]);
};


export const MedicalNoteServiceDetails = ({ row }: { row: PatientMedicalNoteServiceItem }) => {
  const isMobile = useIsMobile(mobileBreakpoint);
  const {
    payment,
    service: {
      cptCodes
    }
  } = row;

  const responsibilities = useMedicalNoteServiceResponsibilities(row);

  return (
    <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
      {isMobile && (
        <Box mt={3}>
          <SessionDetailsDescription row={row} />
        </Box>
      )}
      <Box flex={1} display="flex" flexDirection="column" mt={{ xs: 5, sm: 0 }}>
        <Box flex={1}>
          <BillingDetails
            serviceItemStatus={row.status}
            billing={payment}
            responsibilities={responsibilities}
          />
        </Box>
        {!isMobile && (
          <Box mt={4} display="flex" justifyContent="flex-start">
            <WhatDoTheseTermMeans serviceItem={row} />
          </Box>
        )}
      </Box>
      <Box flex={1} mt={{ xs: 5, sm: 0 }}>
        <DescriptionOfService cptCodes={cptCodes} />
      </Box>
      {isMobile && (
        <Box px={2} mt={4}>
          <WhatDoTheseTermMeans serviceItem={row} />
        </Box>
      )}
    </Box>
  );
};
